import { tamarackAPI, processApiResponse } from "./Tamarack";

export const RfiDataAPI = {
    async rfiReasonsPicklist() {
        const path = `picklistValues?object=Information_Request__c&field=RFI_Reasons__c`;
        const response = await tamarackAPI.get(path);
        return processApiResponse(response, "get", path);
    },

    async addRfi(data, brokerId, email) {
        const path = `rfi`;
        tamarackAPI.setHeader("broker-id", brokerId);
        tamarackAPI.setHeader("email", email);
        const response = await tamarackAPI.post(path, data);
        return processApiResponse(response, "post", path);
    },

    async updateRfi(data, brokerId, email) {
        const path = `rfi`;
        tamarackAPI.setHeader("broker-id", brokerId);
        tamarackAPI.setHeader("email", email);
        const response = await tamarackAPI.put(path, data);
        return processApiResponse(response, "put", path);
    },

    async getById(rfiId, brokerId, email) {
        const path = `rfi/${rfiId}`;
        tamarackAPI.setHeader("broker-id", brokerId)
        tamarackAPI.setHeader("email", email);
        const response = await tamarackAPI.get(path);
        return processApiResponse(response, "get", path);
    },
    async closeRfi(data, brokerId, email) {
        const path = `rfi?action=close`;
        tamarackAPI.setHeader("broker-id", brokerId);
        tamarackAPI.setHeader("email", email);
        const response = await tamarackAPI.put(path, data);
        return processApiResponse(response, "put", path);
    },

};
